// extracted by css-extract-rspack-plugin
export default {"rulesPage":"Rules-module__rulesPage___JGxf7","content":"Rules-module__content___RPR69","glossaryTerm":"Rules-module__glossaryTerm___mctye"};